<template>
    <transition duration="300"
                mode="out-in"
                name="modal"
                @before-enter="beforeEnter"
                @after-enter="afterEnter"
                @after-leave="afterLeave"
    >
        <div v-if="component"
             :class="[$style.TheModal]"
             @click.self="close"
        >
            <div :class="$style.wrapper"
                 @mousedown.self="close"
            >
                <component :is="component"
                           id="modal"
                           ref="componentRef"
                           :is-open="isModalOpen"
                           v-bind="props"
                           data-scroll-lock-scrollable
                           @change="onChange"
                           @close="close"
                           @after-leave="onModalAfterLeave"
                />
            </div>
        </div>
    </transition>
</template>

<script setup lang="ts">
    import { useEventListener } from '@vueuse/core'
    import { storeToRefs } from 'pinia'
    import { useScrollLock } from '~/src/shared/composables/client/scroll-lock/useScrollLock'
    import { useModalStore } from '~/src/shared/pinia/modal/useModalStore'

    const $style = useCssModule()
    const modalStore = useModalStore()

    const { component, props, isModalOpen } = storeToRefs(modalStore)

    const componentRef = ref(null)
    const modalBus = useEventBus('modal')

    const handleKeyListener = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            close()
        }
    }

    const isMounted = ref(false)
    onMounted(() => {
        isMounted.value = true;
        (componentRef.value as unknown as HTMLElement)?.focus()
        useEventListener(document, 'keydown', handleKeyListener)
    })

    function close() {
        modalBus.emit('modal-close')
        isModalOpen.value = false
    }

    const { enableScroll, disableScroll } = useScrollLock()

    function beforeEnter() {
        disableScroll()
    }

    function afterLeave() {
        enableScroll()
    }

    function onModalAfterLeave() {
        modalStore.remove()
    }

    function afterEnter() {
        isModalOpen.value = true
    }

    function onChange(val: string) {
        if (val === 'reset') {
            close()
        }
    }

    // const position = ref({
    //     height: 0,
    //     forClose: 0,
    //     start: {
    //         top: 0,
    //     },
    //
    //     move: {
    //         top: 0,
    //     },
    // });
    //
    // const handleTouchStart = e => {
    //     if (position.value.height === 0) {
    //         const modalInner = e.target.closest('.modal-inner');
    //
    //         position.value.height = modalInner.scrollHeight;
    //         position.value.forClose = position.value.height / 2;
    //     }
    //
    //     position.value.start.top = e.changedTouches[0].screenY;
    // };
    // const handleTouchMove = e => {
    //     if (position.value.start.top > e.changedTouches[0].screenY) {
    //         return;
    //     }
    //
    //     position.value.move.top = e.changedTouches[0].screenY - position.value.start.top;
    // };
    //
    // const bottomSheetClose = () => {
    //     close();
    //     position.value.move.top = 0;
    // };
    // const handleTouchEnd = () => {
    //     if (position.value.move.top >= position.value.forClose) {
    //         bottomSheetClose();
    //     } else {
    //         position.value.move.top = 0;
    //     }
    // };
</script>

<style module
       lang="scss"
>
    .TheModal {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        overflow: hidden;
        width: 100%;
        height: 100%;

        &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: var(--modal-overlay);
            pointer-events: none;
        }
    }

    .wrapper {
        position: relative;
        z-index: 2;
        display: flex;
        justify-content: center;
        flex-flow: column;
        width: 100%;
        height: 100%;
    }
</style>
